import React, { useState, useEffect } from 'react';
import PropertyList from './PropertyList';
import { useTranslation } from 'react-i18next';

function PropertyListContainer({ filteredProperties, openModal, favoriteProperties, toggleFavorite, currency }) {
  const [visibleCount, setVisibleCount] = useState(3); // เริ่มต้นแสดง 3 การ์ด
  const [isMobile, setIsMobile] = useState(false);
  const { t } = useTranslation();

  const handleLoadMore = () => {
    setVisibleCount(prev => prev + 3); // เพิ่มอีก 3 การ์ด
  };

  // ตรวจสอบขนาดหน้าจอ
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const displayProperties = filteredProperties.slice(0, visibleCount);

  return (
    <div>
      {/* Container การ์ด */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
          gap: '16px',
        }}
      >
        {displayProperties.map((property) => (
          <PropertyList
            key={property.property_id}
            properties={[property]} // ส่งเป็น array 1 element เพราะ PropertyList อาจรับ array
            openModal={openModal}
            favorites={favoriteProperties}
            toggleFavorite={toggleFavorite}
            currency={currency}
          />
        ))}
      </div>

      {/* ปุ่มดูเพิ่มเติม */}
      {visibleCount < filteredProperties.length && (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button
            onClick={handleLoadMore}
            style={{
              padding: '12px 25px',
              fontSize: '16px',
              fontWeight: '600',
              backgroundColor: '#dd9e2a',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
              fontFamily: "'Roboto Condensed', 'Kanit', sans-serif"
            }}
            onMouseOver={e => e.currentTarget.style.backgroundColor = '#c4871f'}
            onMouseOut={e => e.currentTarget.style.backgroundColor = '#dd9e2a'}
          >
            {t('See more')}
          </button>
        </div>
      )}
    </div>
  );
}

export default PropertyListContainer;
